import React, { Fragment} from 'react';

const BadgesUsage = () => (
  <Fragment>
    <section>
      <article className="flex-justify-end flex-row">
        <div className="left">
          <h1 className="page-title">
            Through colour and text, badges are small status descriptors for UI elements.
          </h1>
        </div>
        <div className="right copy-content">
          <p>Badges are used to indicate the status of a given element, they are non-interactive elements (not clickable) that highlight content on a page and give visual cue through text and color of status.</p>
        </div>
      </article>
    </section>

    <section className="bg-grey with-padding flex-grow-1">
      <article className="flex-justify-end flex-row">
        <div className="right copy-content">
          <h2 className="page-subtitle">Colour and Label</h2>
          <p>Both colour and label should complement each other in order to transmit the desired message to the user. For confirmation statuses, the colour of choice should be green and as an opposite, the red colour is used when something failed or has expired. In the middle, we have the orange colour for actions that need to be validated in some way. The Purple, Blue and Black colours are used in some specific cases and the UX Designer should make the decision to choose the most indicated colour.</p>
        </div>
      </article>
    </section>
  </Fragment>
);

export default BadgesUsage;


// WEBPACK FOOTER //
// ./src/containers/elements/Badges/BadgesUsage.js